module.exports = __webpack_public_path__ + "img/hr-tree-01-f-trunk.5cce9654.png";